import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdDelete, MdOutlineAutorenew, MdSchedule } from "react-icons/md";
import moment from "moment";
import { EditButton, ModalHeader, ModalRow, ModalRowValue, ModalSection, ModalSectionTitle, ScrollableContent } from "../../Styles/InputStyles";
import { getNatureName, truncateText } from "../../../helpers";
import { Link } from "react-router-dom";
import { FaClockRotateLeft } from "react-icons/fa6";

const RecurringView = ({
  setIsViewExpense,
  selectedData,
  setIsEditExpense,
  setIsDeleteExpense,
  setPropId,
  filter,
  setIsEditRecurringExpense,
  setIsConvertAutoPay
}) => {

  const property = selectedData?.propertyList?.[0] || {};
  const asset = selectedData?.asset || {};
  const flat = selectedData?.flatList?.[0] || {};
  React.useEffect(() => {
    if (property?.id) {
      setPropId(property.id);
    }
  }, [property, setPropId]);

  const onClose = () => {
    setIsViewExpense(false);
  };

  const handleDeleteExpense = () => {
    setIsDeleteExpense(true);
    if (property?.id) {
      setPropId(property.id);
    }
    // setPropId(property?.id);
  };

  const handleAutoPayExpense = () => {
    setIsConvertAutoPay(true);

  };

  const getStatusBadge = (status) => {
    const statusStyles = {
      1: "bg-gray-200 text-gray-600 text-xs border-gray-100 border w-18 h-7 flex items-center justify-center rounded-full",
      2: "bg-gray-200 text-gray-600 text-xs border-gray-100 border w-18 h-7 flex items-center justify-center rounded-full",
    };

    const statusText = {
      1: "One Time",
      2: "Monthly",
    };

    return (
      <span
        className={`px-4 py-2 rounded-full text-xs font-semibold ${statusStyles[status] || "bg-gray-100 text-gray-800"
          }`}
      >
        {statusText[status] || "Not Assigned"}
      </span>
    );
  };

  const getPayentCycle = (paymentCycle) => {
    const statusText = {
      1: "Advance",
      2: "Month End",
    };

    return (
      <span>
        {statusText[paymentCycle] || "Not Assigned"}
      </span>
    );
  };

  return (
    <Container>
      <ModalHeader>
        <Title>Recurring Expense Details</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>
      <ProfileSection className="flex justify-between">
        <UserInfo>
          <span className="font-medium mb-0">₹{selectedData?.amount}</span>
          <span className="text-sm text-gray-600">{selectedData?.name}</span>
        </UserInfo>
        <div className="flex gap-3">
          {filter !== "RE" &&
            <span>{getStatusBadge(selectedData?.repetitionType)}</span>}
          {/* {filter === "RE" && selectedData?.canConvertToAutopay === 1 &&
            <FaClockRotateLeft
              size={16}
              className="text-gray-500 cursor-pointer mt-1.5"
              title="Enable/Disable AutoPay"
              onClick={handleAutoPayExpense}
            />
          } */}
          {filter === "RE" && selectedData?.canConvertToAutopay === 1 && (
            <AutoPayButton
              $enabled={selectedData?.isAutopay === 1}
              onClick={handleAutoPayExpense}
              title={
                selectedData?.isAutopay === 1
                  ? "Disable Auto Pay"
                  : "Enable Auto Pay"
              }
            >
              <MdOutlineAutorenew size={16} />

              <span>
                Auto Pay
              </span>

              <AutoPayStatus $enabled={selectedData?.isAutopay === 1}>
                {selectedData?.isAutopay === 1 ? "ON" : "OFF"}
              </AutoPayStatus>
            </AutoPayButton>
          )}
          {selectedData?.isAutopay !== 1 &&
            <MdDelete
              size={20}
              className="text-rose-500 cursor-pointer mt-1"
              title="Delete Expense"
              onClick={handleDeleteExpense}
            />}

        </div>
      </ProfileSection>
      <Content>
        <ScrollableContent>
          <Wrapper>
            <BtnWrapper>
              <ModalSectionTitle>Expense Details</ModalSectionTitle>
              {/* {filter !== "UM" &&  */}
              {filter !== "UM" && !(filter === "RE" && selectedData?.isAutopay === 1) && (
                <EditButton
                  title="Edit Basic Detail"
                  onClick={() => {
                    setIsViewExpense(false);
                    if (filter === "RE") {
                      setIsEditRecurringExpense(true);
                    } else {
                      setIsEditExpense(true);
                    }
                  }}
                >
                  Edit
                </EditButton>)}
            </BtnWrapper>
            <ModalSection>
              <ModalRow>
                <FlexCol>
                  <LabelShow>Amount Paid</LabelShow>
                  <ModalRowValue>₹{selectedData?.amount}</ModalRowValue>
                </FlexCol>

                <FlexCol>
                  <LabelShow>{(filter !== "RE" && filter !== "UM")
                    ? "Paid Date"
                    : "Due Date"}</LabelShow>
                  <ModalRowValue>
                    {(filter !== "RE" && filter !== "UM")
                      ? moment(selectedData?.paidDate).format("DD-MMM-YY")
                      : moment(selectedData?.dueDate).format("DD-MMM-YY")}
                  </ModalRowValue>
                </FlexCol>
              </ModalRow>
              <ModalRow>
                <FlexCol>
                  <LabelShow>Paid To</LabelShow>
                  <ModalRowValue>{truncateText(selectedData?.paidToName, 20)}</ModalRowValue>
                </FlexCol>
                <FlexCol className="mb-0">
                  <LabelShow>Paid By</LabelShow>
                  <ModalRowValue> {truncateText(selectedData?.paidByName, 20)}</ModalRowValue>
                </FlexCol>
              </ModalRow>
              {filter === "RE" &&
                <ModalRow >
                  <FlexCol>
                    <LabelShow>Recurring After</LabelShow>
                    <ModalRowValue>
                      {selectedData?.noOfMonths + " Month/s"}
                    </ModalRowValue>
                  </FlexCol>
                  <FlexCol>
                    <LabelShow>Payment Cycle</LabelShow>
                    <ModalRowValue>
                      {/* {selectedData?.paymentCycle} */}
                      <span>{getPayentCycle(selectedData?.paymentCycle)}</span>
                    </ModalRowValue>
                  </FlexCol>
                </ModalRow>
              }
              <ModalRow>
                <FlexCol>
                  <LabelShow>Nature of Expense</LabelShow>
                  <ModalRowValue>
                    {getNatureName(selectedData?.expenseNature) || "--"}
                  </ModalRowValue>
                </FlexCol>
              </ModalRow>
              {property?.name &&
                <ModalRow>

                  <FlexCol>
                    <LabelShow>Property</LabelShow>
                    <ModalRowValue>{flat?.name
                      ? `Flat ${flat?.name} (${property?.name})`
                      : `${property?.name}`}
                      {/* {property?.name} */}
                    </ModalRowValue>
                  </FlexCol>
                </ModalRow>}
              {asset?.name &&
                <ModalRow>

                  <FlexCol>
                    <LabelShow>Asset</LabelShow>
                    <ModalRowValue>{`${asset?.name}`}
                    </ModalRowValue>
                  </FlexCol>
                  <FlexCol>
                    <LabelShow>Vehicle Number</LabelShow>
                    <ModalRowValue>
                      {`${asset?.vehicleNum}`}
                    </ModalRowValue>
                  </FlexCol>
                </ModalRow>}
              {selectedData?.description &&
                <ModalRow>
                  <FlexCol>
                    <LabelShow>Description</LabelShow>
                    <ModalRowValue>{selectedData?.description}</ModalRowValue>
                  </FlexCol>
                </ModalRow>}
              <div className="flex justify-end">
                <FlexCol>
                  <ModalRowValue className="text-blue-500 underline">
                    <Link
                      to={selectedData?.supportDoc}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {selectedData?.supportDoc?.split("/").pop()}
                    </Link>
                  </ModalRowValue>
                </FlexCol>
              </div>
            </ModalSection>
          </Wrapper>
        </ScrollableContent>
      </Content>
    </Container>
  );
};

const AutoPayButton = tw.button`
  flex
  items-center
  gap-1.5
  px-2.5
  py-1.5
  rounded-md
  border
  text-xs
  font-medium
  cursor-pointer
  transition-all duration-200

  ${({ $enabled }) =>
    $enabled
      ? "bg-green-50 border-green-200 text-green-700 hover:bg-green-100"
      : "bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100"
  }
`;

const AutoPayStatus = tw.span`
  px-1.5
  py-0.5
  rounded
  text-[10px]
  font-semibold

  ${({ $enabled }) =>
    $enabled
      ? "bg-green-100 text-green-700"
      : "bg-gray-200 text-gray-500"
  }
`;

const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const LabelShow = tw.label`text-sm text-gray-400 font-normal`;
export default RecurringView;